/**
 * AvailabilityBadge Component
 *
 * Displays availability status as a colored badge.
 */

import { AVAILABILITY_STATUS, type AvailabilityStatus } from '../../config/statusStyles';

interface AvailabilityBadgeProps {
  status: AvailabilityStatus;
  size?: 'sm' | 'md';
}

export default function AvailabilityBadge({ status, size = 'sm' }: AvailabilityBadgeProps) {
  const config = AVAILABILITY_STATUS[status];

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center font-medium ${config.className} ${sizeClasses}`}
    >
      {config.label}
    </span>
  );
}
